import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Pagination } from '../../../shared/pagination/pagination';
import { PaginationOptions } from '../../../shared/pagination/pagination-options';
import { ApiService, FileResponse } from '../../../shared/services/api.service';
import { FileService } from '../../../shared/services/file.service';
import { AssessmentDto } from './assessment-details/assessment.dto';

@Injectable({
  providedIn: 'root',
})
export class AssessmentService {
  private readonly assessmentCreate: Subject<AssessmentDto> = new Subject<AssessmentDto>();
  public assessmentCreated$: Observable<AssessmentDto> = this.assessmentCreate.asObservable();

  constructor(
    private readonly api: ApiService,
    private readonly fileService: FileService,
  ) {}

  public async getInitByBeneficiaryId(beneficiaryId: number): Promise<AssessmentDto> {
    return await this.api.get<AssessmentDto>(environment.api.assessments + '/init/' + beneficiaryId);
  }

  public async findByBeneficiaryId(beneficiaryId: number, options: PaginationOptions): Promise<Pagination<AssessmentDto>> {
    const uri: string = environment.api.assessments + '/beneficiary/' + beneficiaryId;
    return this.api.getPaginated<AssessmentDto>(options.buildUrl(uri));
  }

  public async saveAssessment(assessment: AssessmentDto): Promise<number> {
    const assessmentId: number = await this.api.post<number, AssessmentDto>(environment.api.assessments, assessment);
    this.assessmentCreate.next(assessment);
    return assessmentId;
  }

  public async findById(assessmentId: number): Promise<AssessmentDto> {
    const uri: string = environment.api.assessments + '/' + assessmentId;
    return await this.api.get<AssessmentDto>(uri);
  }

  public async generateDocument(assessmentId: number, signatureData: string): Promise<void> {
    const uri: string = environment.api.assessments + '/' + assessmentId + '/document';
    const { filename, data }: FileResponse = await this.api.postWithFileResponse(uri, { signatureData: signatureData });
    this.fileService.saveAs(data, filename);
  }

  public async delete(id: number): Promise<void> {
    await this.api.delete(environment.api.assessments + '/' + id);
    this.assessmentCreate.next(undefined);
  }
}
